module.exports = __webpack_public_path__ + "media/images/global/menu/close-e11feec2818d79c856f41d6a1be6b26b.svg";